export const initialState: MBNotifyPendingUsersState = {
  promptFromChannelSlug: {},
  shouldNotifyFromChannelSlug: {},
  lastAnsweredAtFromChannelSlug: {},
};

export function notifyPendingUsersReducer(
  state: MBNotifyPendingUsersState = initialState,
  action: NotifyPendingUsersAction,
): MBNotifyPendingUsersState {
  switch (action.type) {
    case 'CHAT:UPDATE_SHOULD_NOTIFY_PENDING_USERS': {
      const { channelSlug, notify } = action.value;
      return {
        ...state,
        shouldNotifyFromChannelSlug: {
          ...state.shouldNotifyFromChannelSlug,
          [channelSlug]: notify,
        },
        lastAnsweredAtFromChannelSlug: {
          ...state.lastAnsweredAtFromChannelSlug,
          [channelSlug]: new Date().toISOString(),
        },
        promptFromChannelSlug: {
          ...state.promptFromChannelSlug,
          [channelSlug]: undefined,
        },
      };
    }

    case 'CHAT:SET_PROMPT_TO_NOTIFY_PENDING': {
      const { channelSlug, messageId, users } = action.value;
      return {
        ...state,
        promptFromChannelSlug: {
          ...state.promptFromChannelSlug,
          [channelSlug]: { messageId, users },
        },
      };
    }

    default:
      return state;
  }
}
